import { OnboardingDocumentType } from '@dtos/document-type';

export interface DocumentNumberLookup {
    regex: RegExp;
    requirements: string;
    eg: string;
    requireExpirationDate: (documentTypes: OnboardingDocumentType[]) => boolean;
}

// Source of truth: https://swipejobs.atlassian.net/browse/SDAO-6
// This can be moved to configuration later
const documentNumberLookupTable: Partial<
    Record<OnboardingDocumentType, DocumentNumberLookup>
> = {
    [OnboardingDocumentType.ALIEN_REG_RECEIPT_CARD_I_551]: {
        regex: /^A\d{9}$/,
        requirements: '"A" char and 9 digits [0-9]',
        eg: 'A965788679',
        requireExpirationDate: () => true,
    },
    [OnboardingDocumentType.FOREIGN_PASSPORT]: {
        regex: /^[A-Za-z0-9]{6,12}$/,
        requirements: '6-12 chars [A-Z, a-z] or digits [0-9]',
        eg: 'HK220111',
        requireExpirationDate: () => true,
    },
    [OnboardingDocumentType.FOREIGN_PASSPORT_MRIV]: {
        regex: /^[A-Za-z0-9]{6,12}$/,
        requirements: '6-12 chars [A-Z, a-z] or digits [0-9]',
        eg: 'HK220111',
        requireExpirationDate: () => true,
    },
    /*
     Covers:
     - Foreign passport with I551 stamp
     - Foreign passport with I94
     */
    [OnboardingDocumentType.FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT]: {
        regex: /^[A-Za-z0-9]{6,12}$/,
        requirements: '6-12 chars [A-Z, a-z] or digits [0-9]',
        eg: 'HK220111',
        requireExpirationDate: (documentTypes: OnboardingDocumentType[]) => [
            OnboardingDocumentType.I_551_STAMP,
            OnboardingDocumentType.I_94
        ].some(additionalDocumentType => documentTypes.includes(additionalDocumentType))
    },
    [OnboardingDocumentType.I_551_STAMP]: {
        regex: /^[a-zA-Z]{3}\d{10}$/,
        requirements: '3 chars [A-Z, a-z] and 10 digits [0-9]',
        eg: 'QLC3856718663',
        requireExpirationDate: () => false,
    },
    [OnboardingDocumentType.PERM_RESIDENT_CARD_I_551]: {
        regex: /^[a-zA-Z]{3}\d{10}$/,
        requirements: '3 chars [A-Z, a-z] and 10 digits [0-9]',
        eg: 'QLC3856718663',
        requireExpirationDate: () => false,
    },
    [OnboardingDocumentType.I_766]: {
        regex: /^[a-zA-Z]{3}\d{10}$/,
        requirements: '3 chars [A-Z, a-z] and 10 digits [0-9]',
        eg: 'MSC0902850001',
        requireExpirationDate: () => true,
    },
    [OnboardingDocumentType.I_94]: {
        regex: /^[0-9A-Za-z]{11}$/,
        requirements: '11 chars [A-Z, a-z] or digits [0-9]',
        eg: '23248457594',
        requireExpirationDate: () => false,
    },
    [OnboardingDocumentType.RECEIPT_FORM_I_94_I_94A]: {
        regex: /^[0-9A-Za-z]{11}$/,
        requirements: '11 chars [A-Z, a-z] or digits [0-9]',
        eg: '23248457594',
        requireExpirationDate: () => true
    },
    [OnboardingDocumentType.PASSPORT]: {
        regex: /^[A-Za-z0-9]{6,9}$/,
        requirements: '6-9 chars [A-Z, a-z] or digits [0-9]',
        eg: '441209747',
        requireExpirationDate: () => true,
    },
    [OnboardingDocumentType.DRIVERS_LICENSE]: {
        regex: /^.*$/,
        requirements: '',
        eg: '',
        requireExpirationDate: () => true,
    },
};

export default documentNumberLookupTable;



// WEBPACK FOOTER //
// ./src/constants/document-number-lookup.ts